// src/components/RequiredLabel.jsx
import React from "react";
import { Typography } from "@mui/material";

const RequiredLabel = ({ label, variant = "h6" }) => {
  return (
    <Typography variant={variant} component="label">
      {label}{" "}
      <Typography
        component="span"
        color="error"
        sx={{ fontWeight: "bold" }}
      >
        *
      </Typography>
    </Typography>
  );
};

export default RequiredLabel;
